export default "__VITE_ASSET__Dmq$08tT__"